window.onload = function() {
	const tabBlocks = document.querySelectorAll(
		'.wp-block-farlo-ui-tabbed-contents'
	);

	tabBlocks.forEach(function(tabBlock, i) {
		const tabLabels = tabBlock.querySelectorAll('.tab-label');
		const tabPanels = tabBlock.querySelectorAll('.tab-panel');

		const setIDs = function(tabItems, i) {
			//dyanamically adds ids to tab and tabpanel elements
			tabItems.forEach(function(element, index) {
				const role = element.getAttribute('role');
				tabItems[ index ].id = `${ role }-${ i }-${ index }`;
				if (tabItems[ index ].classList.contains('tab-label')) {
					tabItems[ index ].setAttribute(
						'data-name',
						tabItems[ index ].innerText
							.toLowerCase()
							.replaceAll(' ', '-')
					);
					tabItems[ index ].setAttribute('data-index', index);
				}
			});
		};
		setIDs(tabLabels, i);
		setIDs(tabPanels, i);

		const setAriaAttributes = function(tabItems, i) {
			//checks role and adds aria-controls and aria-labledby attributes if role is set to tab or tabpanel
			tabItems.forEach(function(element, index) {
				const role = element.getAttribute('role');

				if (role === 'tab') {
					tabItems[ index ].setAttribute(
						'aria-controls',
						`tabpanel-${ i }-${ index }`
					);
				} else if (role === 'tabpanel') {
					tabItems[ index ].setAttribute(
						'aria-labelledby',
						`tab-${ i }-${ index }`
					);
				}
				tabItems[ index ].id = `${ role }-${ i }-${ index }`;
			});
		};
		setAriaAttributes(tabLabels, i);
		setAriaAttributes(tabPanels, i);

		//check for mouse click or enter keypress
		const toggleEvent = function(e) {
			if (e.type === 'click') {
				return true;
			} else if (e.type === 'keypress') {
				const code = e.charCode || e.keyCode;
				if (code === 32 || code === 13) {
					return true;
				}
			} else {
				return false;
			}
		}; //a11yEvent

		function updateHistory(curr) {
			if (typeof window.location.lasthash !== 'undefined') {
				window.location.lasthash.push(window.location.hash);
			}
			window.location.hash = curr;
		}

		function goBack() {
			toggleAttributes(
				document.querySelector(
					'[data-name="' + window.location.hash.split('#')[ 1 ] + '"]'
				),
				document.querySelector(
					'[data-name="' + window.location.hash.split('#')[ 1 ] + '"]'
				).dataset.index
			);
		}

		const toggleAttributes = function(label, i) {
			const activeTab = tabBlock.querySelector('.tab-label.active');
			const activePanel = tabBlock.querySelector('.tab-panel.active');

			activeTab.classList.remove('active');
			activeTab.setAttribute('tabindex', 0);
			activeTab.setAttribute('aria-selected', false);

			label.classList.add('active');
			label.setAttribute('tabindex', -1);
			label.setAttribute('aria-selected', true);

			if (activePanel) {
				activePanel.classList.remove('active');
				activePanel.setAttribute('tabindex', 0);
				activePanel.setAttribute('aria-selected', false);
				activePanel.setAttribute('hidden', true);
			}

			tabPanels[ i ].classList.add('active');
			tabPanels[ i ].removeAttribute('hidden');

			if (label.dataset.name) {
				updateHistory(label.dataset.name);
			}
		};

		tabLabels.forEach(function(label, i) {
			if (
				window.location.hash &&
				window.location.hash.split('#')[ 1 ] === label.dataset.name
			) {
				toggleAttributes(label, i);

				if (label.classList.contains('active')) {
					tabPanels[ i ].classList.toggle('active');
				}
			}

			if (label.classList.contains('active')) {
				tabPanels[ i ].classList.toggle('active');
			}

			label.addEventListener('click', function(e) {
				if (toggleEvent(e) === true) {
					toggleAttributes(label, i);
				}
			});
			label.addEventListener('keypress', function(e) {
				if (toggleEvent(e) === true) {
					toggleAttributes(label, i);
				}
			});
		});

		window.onhashchange = function() {
			if (window.innerDocClick) {
				window.innerDocClick = false;
			} else if (window.location.hash != '#undefined') {
				goBack();
			} else {
				history.pushState(
					'',
					document.title,
					window.location.pathname
				);
			}
		};
	}); //tabBlocks forEach
};
